// extracted by extract-css-chunks-webpack-plugin
module.exports = {"displayAsRow":"app-components-base-infoitem2-licenseinfo--displayAsRow","licenseIcon":"app-components-base-infoitem2-licenseinfo--licenseIcon"};